<template>
  <v-card
    elevation='1'
    class='mb-5'
  >
    <v-card-title v-html="i18nReservationCode"/>

    <v-card-text>
      <v-row>
        <v-icon large class='ml-2'>mdi-book-outline</v-icon>
        <v-col>
          {{ $t('order.attributes.ota') }}<br>
          <strong>{{ order.ota || 'nd' }}</strong>
        </v-col>

        <v-icon large>mdi-home-city-outline</v-icon>
        <v-col>
          {{ $t('reservation.attributes.apartment') }}<br>
          <strong v-html="apartment_link"></strong>
        </v-col>
      </v-row>

      <v-row>
        <v-icon large class='ml-2'>mdi-home-import-outline</v-icon>
        <v-col>
          {{ $t('reservation.attributes.checkin_date') }}<br>
          <strong>{{ formattedDate(reservation.checkin_date) }}</strong>
        </v-col>

        <v-icon large>mdi-home-export-outline</v-icon>
        <v-col>
          {{ $t('reservation.attributes.checkout_date') }}<br>
          <strong>{{ formattedDate(reservation.checkout_date) }}</strong>
        </v-col>
      </v-row>

      <v-row>
        <v-icon large class='ml-2'>mdi-weather-night</v-icon>
        <v-col>
          {{ $t('reservation.attributes.nights') }}<br>
          <strong>{{ bookedNights }}</strong>
        </v-col>

        <v-icon large>mdi-account-multiple</v-icon>
        <v-col>
          {{ $t('reservation.attributes.guests') }}<br>
          <strong>{{ reservation.booked_guests }}</strong>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions v-if="customer" class='pb-3 pt-0'>
        <v-btn
          large
          block
          color='primary'
          :to='{
            name: "checkinGuests",
            params: {
              uuid: this.order.uuid,
              reservation_id: this.reservation.id
            }
          }'
        >
          {{ $t('order.checkin.start') }}
        </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { utilityMixin } from '../../mixins/utility_mixin'
  import { orderCustomerMixin } from '../../mixins/order_customer_mixin'
  import { reservationMixin } from '../../mixins/reservation_mixin'
  import { apartmentMixin } from '../../mixins/apartment_mixin'

  export default {
    mixins: [
      utilityMixin,
      reservationMixin,
      apartmentMixin,
      orderCustomerMixin,
    ],
    props: {
      order: {
        type: Object,
        required: true
      },
      reservation: {
        type: Object,
        required: true
      }
    }
  }
</script>
